export default "__VITE_ASSET__CR6CvPVp__"